/* import "../styles/signUp-in.css";
import { FcGoogle } from "react-icons/fc";
import { FaFacebookF } from "react-icons/fa";
import { BsEyeSlash, BsEye } from "react-icons/bs";
import { useState, useEffect, useRef } from "react";
import { signUpURL } from "../api/endpoints";
import { useNavigate, useSearchParams } from "react-router-dom";
import ConfirmPhoneNumber from "./ConfirmPhoneNumber";
import { useDispatch } from "react-redux";
import { setUser } from "../slice/webStoreUserSlice";
import VerifyPhoneNumber from "./verifications/Phone/VerifyPhoneNumber";
import { ButtonLoader } from "../components/uxCollections/Loaders";
import { uiAlert } from "../components/alerts/customAlert/uiAlert";

import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const SignUp = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [password, setPassword] = useState("");
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [fullName, setFullName] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [openPhoneVerificationModal, setOpenPhoneVerificationModal] = useState(false);

  const dispatch = useDispatch();

  const { executeRecaptcha } = useGoogleReCaptcha();

  const regexForEmail =  /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  const regexForPassword =  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;

  const regexForPublicEmail = /^[a-zA-Z0-9._%+-]+@(gmail\.com|yahoo\.com|yahoo\.co\.uk|outlook\.com|hotmail\.com|icloud\.com|live\.com)$/;
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ref = params.get("ref");
  console.log(ref, "referral code");

  useEffect(() => {
    window.bouncerConfig = {
      apikey: process.env.REACT_APP_BOUNCER_API_KEY,
      feedbackOverlayMessage: "Enter a real email",
      feedbackOverlayPoweredBy: false,
    };

    const script = document.createElement("script");
    script.src = "https://app.usebouncer.com/bouncer-script/bouncer-script-beta.js";
    script.async = true;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

 
  useEffect(() => {
    if (email.length > 3) {
      setIsEmailValid(false);
      if (regexForEmail.test(email)) {
        console.log("email is valid");
        setIsEmailValid(true);
      } else {
        console.log("email is not valid");
        setIsEmailValid(false);
      }
    } else {
    }
  }, [email]);

  useEffect(() => {
    if (password.length > 5) {
      setIsPasswordValid(false);
      if (regexForPassword.test(password)) {
        console.log("password is valid");
        setIsPasswordValid(true);
      } else {
        console.log("password is not valid");
        setIsPasswordValid(false);
      }
    } else {
      setIsPasswordValid(false);
    }
  }, [password]);

  useEffect(() => {
    if (isEmailValid && isPasswordValid && fullName && email) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [password, fullName, isEmailValid, email, isPasswordValid]);

  const signUp = async () => {
    setLoading(true);
    if (!executeRecaptcha) {
      console.log("Recaptcha not ready");
      return;
    }

    const token = await executeRecaptcha("signup");

    if (!token) {
      alert("Please complete the reCAPTCHA");
      return;
    }

    if (isFormValid) {
      const payload = {
        fullName: fullName
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        email: String(email).trim().toLowerCase(),
        password,
        referralID: ref ? ref : null,
        reCaptchaToken: token,
      };
      try {
        let response = await fetch(signUpURL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        if (response.ok) {
          localStorage.setItem("refreshToken", data.refreshToken);
          localStorage.setItem("accessToken", data.accessToken);
         
          dispatch(setUser(data.user));
          //  return navigate("/settings");
          setOpenPhoneVerificationModal(true);
        } else if (response.status === 403) {
          console.log(data.message);

          return uiAlert(data.message, "error");
        } else if (response.status === 404) {
          // email invalid

          return uiAlert(data.message, "error");
        } else {
          return uiAlert("An error occurred, please try again later", "error");
        }
      } catch (error) {
        uiAlert("An error occurred, please try again later", "error");
        return console.log(error);
      } finally {
        setLoading(false);
      }
    } else {
      uiAlert("form is not valid", "error");
    }
  };

  return (
    <>
      <div className='signUpDivNew'>
      

        <div className='signUpFlex33'>
          <div>
            <div>{logo}</div>
            <div className='signUpFormDiv'>
              
              <h1 className='titleLoginSignUp'>Sign Up and Get Started</h1>
              <p style={{ fontSize: "16px", fontWeight: "600" }}>
                Already have an account?{" "}
                <span
                  style={{
                    color: "#0E49B5",
                    fontWeight: "bold",
                    cursor: "pointer",
                    marginLeft: "5px",
                    textDecoration: "underline",
                  }}
                  onClick={() => navigate("/sign-in")}
                >
                  Log in
                </span>
              </p>
              <div className='SocialSignDiv'>
                <div>
                  <FcGoogle />
                  <p className='SocialSignSocilap'>Sign up with google</p>
                </div>
               
              </div>
              <div className='OrwithDiv'>
                <div></div>
                <p>or </p>
                <div></div>
              </div>
              <div className='forminputDiv'>
                <div className='inputFieldAnimated'>
                  <input
                    onKeyDown={(e) => isFormValid && e.key === "Enter" && signUp()}
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    type={"text"}
                    required={true}
                  />
                  <p>Full name*</p>
                </div>

                <div className='inputFieldAnimated'>
                  <input
                    name='email'
                    onKeyDown={(e) => isFormValid && e.key === "Enter" && signUp()}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type={"text"}
                    required={true}
                  />
                  <p>Email*</p>
                </div>
                {!isEmailValid && email.length > 6 && (
                  <p style={{ marginTop: "-25px" }} className='emailValidationP'>
                    Email invalid
                  </p>
                )}
                <div className='inputFieldAnimated passwordIn'>
                  <input
                    onKeyDown={(e) => isFormValid && e.key === "Enter" && signUp()}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type={showPassword ? "text" : "password"}
                    required={true}
                  />
                  <p>Password*</p>
                  {showPassword ? (
                    <BsEye style={{ cursor: "pointer" }} onClick={() => setShowPassword(false)} />
                  ) : (
                    <BsEyeSlash style={{ cursor: "pointer" }} onClick={() => setShowPassword(true)} />
                  )}
                </div>
                {!isPasswordValid && password.length > 5 && (
                  <p className='emailValidationP'>Password must contain atlest 6 letters one Number, one Uppercase and one Lowercase </p>
                )}
                <div className='iAgree'>
                  <p>
                    By signing up you agree with the <span style={{ color: "rgb(14,73,181)", fontWeight: "bold" }}>Terms of Service</span> and{" "}
                    <span style={{ color: "rgb(14,73,181)", fontWeight: "bold" }}>Privacy Policy</span>{" "}
                  </p>
                </div>
               
                {isFormValid ? (
                  loading ? (
                    <button style={isFormValid ? {} : { pointerEvents: "none", opacity: 0.7, disabled: "true" }} className='signUpbutton'>
                      {" "}
                      <ButtonLoader />{" "}
                    </button>
                  ) : (
                    <button
                      onClick={() => signUp()}
                      style={isFormValid ? {} : { pointerEvents: "none", opacity: 0.7, disabled: "true" }}
                      className='signUpbutton'
                    >
                      {" "}
                      Sign up
                    </button>
                  )
                ) : (
                  <button style={isFormValid ? {} : { pointerEvents: "none", opacity: 0.7, disabled: "true" }} className='signUpbutton'>
                    {" "}
                    Sign up
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className='signUpDisp33'>
            <div className='displTex55Di'>
              <h2>Manage your store inventory in Real-Time</h2>
              <p>With Storelense, you never loose track of your products</p>
            </div>
            <div className='intrImag'>
              <img src='https://res.cloudinary.com/ebuka1122/image/upload/v1748085359/StorelenseLogos/Group_2839_u3xm7u.png' alt='sign up image' />
            </div>
          </div>
        </div>
      </div>
      {openPhoneVerificationModal && <VerifyPhoneNumber closeModal={setOpenPhoneVerificationModal} />}
    </>
  );
};

export default SignUp; */

/* const logo = (
  <svg xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' width='46' height='46' viewBox='0 0 46 46'>
    <defs>
      <filter id='Ellipse_272'>
        <feOffset dx='-1' dy='1' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='5' result='blur' />
        <feFlood flood-color='#0f0f0f' flood-opacity='0.161' result='color' />
        <feComposite operator='out' in='SourceGraphic' in2='blur' />
        <feComposite operator='in' in='color' />
        <feComposite operator='in' in2='SourceGraphic' />
      </filter>
      <radialGradient
        id='radial-gradient'
        cx='0.862'
        cy='0.237'
        r='1.394'
        gradientTransform='translate(-0.13 0.179) rotate(-17.999)'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#5070a1' />
        <stop offset='1' stop-color='#0e49b5' />
      </radialGradient>
      <filter id='Subtraction_13' x='0.877' y='3.011' width='28.944' height='28.862' filterUnits='userSpaceOnUse'>
        <feOffset dx='-3' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='3' result='blur-2' />
        <feFlood flood-color='#434343' flood-opacity='0.161' />
        <feComposite operator='in' in2='blur-2' />
        <feComposite in='SourceGraphic' />
      </filter>
      <filter id='Subtraction_23' x='15.434' y='17.402' width='28.862' height='28.413' filterUnits='userSpaceOnUse'>
        <feOffset dy='3' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='3' result='blur-3' />
        <feFlood flood-color='#464646' flood-opacity='0.161' />
        <feComposite operator='in' in2='blur-3' />
        <feComposite in='SourceGraphic' />
      </filter>
    </defs>
    <g id='Group_2614' data-name='Group 2614' transform='translate(-0.037 -0.1)'>
      <g data-type='innerShadowGroup'>
        <circle id='Ellipse_272-2' data-name='Ellipse 272' cx='23' cy='23' r='23' transform='translate(0.037 0.099)' fill='#fff' />
        <g transform='matrix(1, 0, 0, 1, 0.04, 0.1)' filter='url(#Ellipse_272)'>
          <circle id='Ellipse_272-3' data-name='Ellipse 272' cx='23' cy='23' r='23' transform='translate(0 0)' fill='#fff' />
        </g>
        <g id='Ellipse_272-4' data-name='Ellipse 272' transform='translate(0.037 0.099)' fill='none' stroke='#0e49b5' stroke-width='2'>
          <circle cx='23' cy='23' r='23' stroke='none' />
          <circle cx='23' cy='23' r='22' fill='none' />
        </g>
      </g>
      <circle id='Ellipse_273' data-name='Ellipse 273' cx='18' cy='18' r='18' transform='translate(5.037 5.099)' fill='#c8a027' />
      <circle id='Ellipse_274' data-name='Ellipse 274' cx='17.5' cy='17.5' r='17.5' transform='translate(6.037 5.099)' fill='#fff' />
      <g id='Group_2610' data-name='Group 2610' transform='translate(12.416 12.111)'>
        <g transform='matrix(1, 0, 0, 1, -12.38, -12.01)' filter='url(#Subtraction_13)'>
          <path
            id='Subtraction_13-2'
            data-name='Subtraction 13'
            d='M10.943,10.862H0A10.554,10.554,0,0,1,3.19,3.326,11.63,11.63,0,0,1,10.944,0V10.861h0Z'
            transform='translate(12.88 12.01)'
            fill='url(#radial-gradient)'
          />
        </g>
        <path
          id='Subtraction_25'
          data-name='Subtraction 25'
          d='M10.8,0H0A10.623,10.623,0,0,0,3.148,7.536,11.406,11.406,0,0,0,10.8,10.862V0h0Z'
          transform='translate(22.854 10.862) rotate(180)'
          fill='#37b4c5'
        />
        <path
          id='Subtraction_17'
          data-name='Subtraction 17'
          d='M10.412,10.862H0A10.87,10.87,0,0,1,10.413,0V10.861h0Z'
          transform='translate(0.58 21.805) rotate(-90)'
          fill='#37b4c5'
        />
        <g transform='matrix(1, 0, 0, 1, -12.38, -12.01)' filter='url(#Subtraction_23)'>
          <path
            id='Subtraction_23-2'
            data-name='Subtraction 23'
            d='M10.412,0H0A10.825,10.825,0,0,0,3.035,7.536a10.813,10.813,0,0,0,7.378,3.325V0h0Z'
            transform='translate(24.43 33.82) rotate(-90)'
            fill='#0e49b5'
          />
        </g>
        <path
          id='Subtraction_12'
          data-name='Subtraction 12'
          d='M22.232,0H0A10.218,10.218,0,0,0,3.405,7.138a11.416,11.416,0,0,0,7.711,2.936,11.416,11.416,0,0,0,7.711-2.936A10.217,10.217,0,0,0,22.232,0Z'
          transform='translate(23.528 10.636) rotate(180)'
          fill='#fff'
        />
        <path
          id='Subtraction_26'
          data-name='Subtraction 26'
          d='M22.232,10.075H0A10.218,10.218,0,0,1,3.4,2.936,11.416,11.416,0,0,1,11.116,0a11.415,11.415,0,0,1,7.711,2.936,10.218,10.218,0,0,1,3.4,7.138Z'
          transform='translate(22.232 21.268) rotate(180)'
          fill='#fff'
        />
        <path id='Path_3551' data-name='Path 3551' d='M0,0H22.416' transform='translate(0.499 11.014)' fill='none' stroke='#0e49b5' stroke-width='1' />
      </g>
    </g>
  </svg>
); */

import { useState, useEffect } from "react";
import { FcGoogle } from "react-icons/fc";
import { BsEyeSlash, BsEye } from "react-icons/bs";
import { signUpURL } from "../api/endpoints";
import { useNavigate, useSearchParams } from "react-router-dom";
import VerifyPhoneNumber from "./verifications/Phone/VerifyPhoneNumber";
import { useDispatch } from "react-redux";
import { setUser } from "../slice/webStoreUserSlice";
import { ButtonLoader, ButtonLoaderII } from "../components/uxCollections/Loaders";
import { uiAlert } from "../components/alerts/customAlert/uiAlert";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import "../styles/LoginAndCreate/SignUp.css";

const SignUp = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [password, setPassword] = useState("");
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [fullName, setFullName] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openPhoneVerificationModal, setOpenPhoneVerificationModal] = useState(false);

  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const regexForEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  const regexForPassword = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;

  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ref = params.get("ref");

  useEffect(() => {
    window.bouncerConfig = {
      apikey: process.env.REACT_APP_BOUNCER_API_KEY,
      feedbackOverlayMessage: "Enter a real email",
      feedbackOverlayPoweredBy: false,
    };

    const script = document.createElement("script");
    script.src = "https://app.usebouncer.com/bouncer-script/bouncer-script-beta.js";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (email.length > 3) {
      setIsEmailValid(regexForEmail.test(email));
    }
  }, [email]);

  useEffect(() => {
    if (password.length > 5) {
      setIsPasswordValid(regexForPassword.test(password));
    } else {
      setIsPasswordValid(false);
    }
  }, [password]);

  useEffect(() => {
    if (isEmailValid && isPasswordValid && fullName && email) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [password, fullName, isEmailValid, email, isPasswordValid]);

  const signUp = async () => {
    setLoading(true);
    if (!executeRecaptcha) {
      setLoading(false);
      return;
    }

    const token = await executeRecaptcha("signup");

    if (!token) {
      uiAlert("Please complete the reCAPTCHA", "error");
      setLoading(false);
      return;
    }

    if (isFormValid) {
      const payload = {
        fullName: fullName
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        email: String(email).trim().toLowerCase(),
        password,
        referralID: ref ? ref : null,
        reCaptchaToken: token,
      };
      try {
        let response = await fetch(signUpURL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        if (response.ok) {
          localStorage.setItem("refreshToken", data.refreshToken);
          localStorage.setItem("accessToken", data.accessToken);
          dispatch(setUser(data.user));
          setOpenPhoneVerificationModal(true);
        } else if (response.status === 403) {
          uiAlert(data.message, "error");
        } else if (response.status === 404) {
          uiAlert(data.message, "error");
        } else {
          uiAlert("An error occurred, please try again later", "error");
        }
      } catch (error) {
        uiAlert("An error occurred, please try again later", "error");
      } finally {
        setLoading(false);
      }
    } else {
      uiAlert("form is not valid", "error");
      setLoading(false);
    }
  };

  return (
    <>
      <div className='signup-page'>
        <main className='signup-page__form'>
          <div className='signup-card'>
            <div className='signup-card__brand'>
              <img src='/StorelenseLogo.png' alt='StoreLense' />
              <span>
                Store<span>Lense</span>
              </span>
            </div>

            <h1 className='signup-card__title'>Sign up and get started</h1>
            <p className='signup-card__subtitle'>
              Already have an account?
              <span onClick={() => navigate("/sign-in")}> Log in</span>
            </p>

            <button type='button' className='signup-card__social'>
              <FcGoogle size={19} />
              <span>Sign up with Google</span>
            </button>

            <div className='signup-divider'>
              <span>or sign up with email</span>
            </div>

            <div className='signup-field'>
              <input
                id='signup-fullname'
                type='text'
                placeholder=' '
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                onKeyDown={(e) => isFormValid && e.key === "Enter" && signUp()}
              />
              <label htmlFor='signup-fullname'>Full name</label>
            </div>

            <div className={`signup-field ${!isEmailValid && email.length > 6 ? "signup-field--error" : ""}`}>
              <input
                id='signup-email'
                name='email'
                type='text'
                placeholder=' '
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => isFormValid && e.key === "Enter" && signUp()}
              />
              <label htmlFor='signup-email'>Email</label>
            </div>
            {!isEmailValid && email.length > 6 && <p className='signup-field__message'>Enter a valid email address</p>}

            <div className='signup-field'>
              <input
                id='signup-password'
                type={showPassword ? "text" : "password"}
                placeholder=' '
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => isFormValid && e.key === "Enter" && signUp()}
              />
              <label htmlFor='signup-password'>Password</label>
              <button
                type='button'
                className='signup-field__toggle'
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <BsEye size={17} /> : <BsEyeSlash size={17} />}
              </button>
            </div>
            {!isPasswordValid && password.length > 5 && (
              <p className='signup-field__message'>Password needs 6+ characters with a number, an uppercase and a lowercase letter</p>
            )}

            <p className='signup-card__terms'>
              By signing up you agree with the{" "}
              <span
                onClick={() => {
                  window.open("https://storelense.com/terms", "_blank");
                }}
              >
                Terms of Service
              </span>{" "}
              and{" "}
              <span
                onClick={() => {
                  window.open("https://storelense.com/data-policy", "_blank");
                }}
              >
                Privacy Policy
              </span>
            </p>

            <button type='button' className='signup-card__submit' disabled={!isFormValid || loading} onClick={signUp}>
              {loading ? <ButtonLoaderII /> : "Sign up"}
            </button>
          </div>
        </main>

        <aside className='signup-page__visual'>
          <div className='signup-page__visual-glow signup-page__visual-glow--warm' />
          <div className='signup-page__visual-glow signup-page__visual-glow--cool' />
          <div className='signup-page__visual-copy'>
            <h2>Manage your store inventory in real-time</h2>
            <p>With StoreLense, you never lose track of your products.</p>
          </div>
          <div className='signup-page__visual-image'>
            <img src={"/storelense_woman.png"} alt='StoreLense illustration' />
          </div>
        </aside>
      </div>

      {openPhoneVerificationModal && <VerifyPhoneNumber closeModal={setOpenPhoneVerificationModal} />}
    </>
  );
};

export default SignUp;

const logo = (
  <svg xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' width='195.495' height='61.337' viewBox='0 0 265.495 61.337'>
    <defs>
      <filter id='Ellipse_272'>
        <feOffset dx='-1' dy='1' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='5' result='blur' />
        <feFlood flood-color='#d8d4d4' flood-opacity='0.161' result='color' />
        <feComposite operator='out' in='SourceGraphic' in2='blur' />
        <feComposite operator='in' in='color' />
        <feComposite operator='in' in2='SourceGraphic' />
      </filter>
      <radialGradient
        id='radial-gradient'
        cx='0.862'
        cy='0.237'
        r='1.394'
        gradientTransform='translate(-0.13 0.179) rotate(-17.999)'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#5070a1' />
        <stop offset='1' stop-color='#0e49b5' />
      </radialGradient>
      <filter id='Subtraction_13' x='4.458' y='8.174' width='28.944' height='28.862' filterUnits='userSpaceOnUse'>
        <feOffset dx='-3' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='3' result='blur-2' />
        <feFlood flood-color='#434343' flood-opacity='0.161' />
        <feComposite operator='in' in2='blur-2' />
        <feComposite in='SourceGraphic' />
      </filter>
      <filter id='Subtraction_23' x='20.834' y='23.699' width='28.862' height='28.964' filterUnits='userSpaceOnUse'>
        <feOffset dy='3' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='3' result='blur-3' />
        <feFlood flood-color='#464646' flood-opacity='0.161' />
        <feComposite operator='in' in2='blur-3' />
        <feComposite in='SourceGraphic' />
      </filter>
    </defs>
    <g id='Group_2823' data-name='Group 2823' transform='translate(-7468.505 -2671.663)'>
      <g id='Group_2822' data-name='Group 2822'>
        <g id='Group_2820' data-name='Group 2820'>
          <g id='Group_2819' data-name='Group 2819' transform='translate(0 1)'>
            <g id='Group_2821' data-name='Group 2821'>
              <g id='Group_2816' data-name='Group 2816' transform='translate(7481.663 2670.663)'>
                <g id='Group_2614' data-name='Group 2614' transform='translate(-13.158)'>
                  <g data-type='innerShadowGroup'>
                    <circle id='Ellipse_272-2' data-name='Ellipse 272' cx='27' cy='27' r='27' transform='translate(1.495 1.337)' fill='#fff' />
                    <g transform='matrix(1, 0, 0, 1, 0, 0)' filter='url(#Ellipse_272)'>
                      <circle id='Ellipse_272-3' data-name='Ellipse 272' cx='27' cy='27' r='27' transform='translate(1.49 1.34)' fill='#fff' />
                    </g>
                    <g id='Ellipse_272-4' data-name='Ellipse 272' transform='translate(1.495 1.337)' fill='none' stroke='#0e49b5' stroke-width='2'>
                      <circle cx='27' cy='27' r='27' stroke='none' />
                      <circle cx='27' cy='27' r='26' fill='none' />
                    </g>
                  </g>
                  <circle id='Ellipse_273' data-name='Ellipse 273' cx='20.17' cy='20.17' r='20.17' transform='translate(25.93 0) rotate(40)' fill='#c8a027' />
                  <circle id='Ellipse_274' data-name='Ellipse 274' cx='19.67' cy='19.67' r='19.67' transform='translate(26.696 0.643) rotate(40)' fill='#fff' />
                  <g id='Group_2610' data-name='Group 2610' transform='translate(15.961 17.174)'>
                    <g transform='matrix(1, 0, 0, 1, -15.96, -17.17)' filter='url(#Subtraction_13)'>
                      <path
                        id='Subtraction_13-2'
                        data-name='Subtraction 13'
                        d='M10.943,10.862H0A10.554,10.554,0,0,1,3.19,3.326,11.63,11.63,0,0,1,10.944,0V10.861h0Z'
                        transform='translate(16.46 17.17)'
                        fill='url(#radial-gradient)'
                      />
                    </g>
                    <path
                      id='Subtraction_25'
                      data-name='Subtraction 25'
                      d='M10.8,0H0A10.623,10.623,0,0,0,3.148,7.536,11.406,11.406,0,0,0,10.8,10.862V0h0Z'
                      transform='translate(24.673 10.862) rotate(180)'
                      fill='#37b4c5'
                    />
                    <path
                      id='Subtraction_17'
                      data-name='Subtraction 17'
                      d='M10.412,10.862H0A10.87,10.87,0,0,1,10.413,0V10.861h0Z'
                      transform='translate(0.58 23.49) rotate(-90)'
                      fill='#37b4c5'
                    />
                    <g transform='matrix(1, 0, 0, 1, -15.96, -17.17)' filter='url(#Subtraction_23)'>
                      <path
                        id='Subtraction_23-2'
                        data-name='Subtraction 23'
                        d='M10.964,0H0A10.544,10.544,0,0,0,3.2,7.536a11.663,11.663,0,0,0,7.768,3.325V0h0Z'
                        transform='translate(29.83 40.66) rotate(-90)'
                        fill='#0e49b5'
                      />
                    </g>
                    <path
                      id='Subtraction_12'
                      data-name='Subtraction 12'
                      d='M24.051,0H0A9.931,9.931,0,0,0,3.684,7.138a12.94,12.94,0,0,0,8.342,2.936,12.94,12.94,0,0,0,8.342-2.936A9.93,9.93,0,0,0,24.051,0Z'
                      transform='translate(25.347 10.636) rotate(180)'
                      fill='#fff'
                    />
                    <path
                      id='Subtraction_26'
                      data-name='Subtraction 26'
                      d='M24.051,11.075H0A11.308,11.308,0,0,1,3.684,3.227a12.393,12.393,0,0,1,16.683,0,11.308,11.308,0,0,1,3.684,7.846Z'
                      transform='translate(24.051 22.954) rotate(180)'
                      fill='#fff'
                    />
                    <path
                      id='Path_3551'
                      data-name='Path 3551'
                      d='M0,0H24.235'
                      transform='translate(0.499 11.142)'
                      fill='none'
                      stroke='#0e49b5'
                      stroke-width='1'
                    />
                    <path
                      id='Path_6314'
                      data-name='Path 6314'
                      d='M0,0H24.235'
                      transform='translate(0.5 12.142)'
                      fill='none'
                      stroke='#0e49b5'
                      stroke-width='1'
                    />
                  </g>
                </g>
                <text id='STORELENSE' transform='translate(49.337 47.337)' fill='#0e49b5' font-size='39' font-family='Nunito-Bold, Nunito' font-weight='700'>
                  <tspan x='0' y='0'>
                    Store
                  </tspan>
                  <tspan y='0' fill='#37b4c5' font-family='Nunito-SemiBold, Nunito' font-weight='600'>
                    Lense
                  </tspan>
                </text>
              </g>
              <rect id='Rectangle_3090' data-name='Rectangle 3090' width='3' height='3' rx='1.5' transform='translate(7596.26 2714.684)' fill='#fff' />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
